/*
 * Nice Ice – penguin basket stage (adapted from the Nice-Ice-Penguin-Claude package).
 * Purely visual: the order builder's own state is the source of truth. Nothing here
 * blocks, awaits or locks the cart. API on the stage element: playAdd, playRemove,
 * syncCart, celebrate, cancel, destroy.
 */
(function () {
  function NicePenguinStage(root) {
    var stage = root.querySelector('.np-stage');
    var penguin = root.querySelector('.np-penguin');
    var parcel = root.querySelector('.np-parcel');
    var basket = root.querySelector('.np-basket');
    var bubble = root.querySelector('.np-bubble');
    var count = root.querySelector('.np-count');
    var sparkLayer = root.querySelector('.np-sparkles');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var raf = 0, busy = false, pending = null, geo = null, celebrated = {}, alive = true;
    var lines = { add: ['Into the basket!', 'Ice, delivered.', 'Leave it to me!'], remove: 'Taking one back.' };
    var n = 0;

    function measure() {
      var w = stage.clientWidth, s = w < 345 ? 92 : 108, ground = stage.clientHeight - 14;
      geo = { w: w, s: s, y: ground - s * 0.935, home: 8, bx: w - 104, py: ground - 54, by: ground - 40 };
      penguin.style.width = s + 'px'; penguin.style.height = s + 'px';
    }
    function sprite(frame, clap) {
      penguin.classList.toggle('np-clap', !!clap);
      penguin.style.backgroundPosition = clap ? (frame % 2 ? '100% 0' : '0 0') : (frame % 2 ? '100%' : '0') + ' ' + (frame > 1 ? '100%' : '0');
    }
    function place(x, y, a, sc) { penguin.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + (a || 0) + 'deg) scale(' + (sc || 1) + ')'; }
    function bag(x, y, a, sc, op) { parcel.style.transform = 'translate(' + x + 'px,' + y + 'px) rotate(' + (a || 0) + 'deg) scale(' + (sc || 1) + ')'; parcel.style.opacity = op; }
    function idle() { if (!geo) measure(); sprite(0); place(geo.home, geo.y); parcel.style.opacity = '0'; basket.style.transform = ''; root.dataset.motion = 'idle'; }
    function lerp(a, b, t) { return a + (b - a) * t; }
    function ease(t) { return 1 - Math.pow(1 - t, 3); }
    function clamp(t) { return t < 0 ? 0 : t > 1 ? 1 : t; }
    function hidden() { return document.hidden || !root.isConnected; }

    function sparkle(x, y, many) {
      if (reduced.matches || !sparkLayer.animate) return;
      for (var i = 0; i < (many ? 18 : 6); i++) {
        var p = document.createElement('span');
        p.style.left = x + 'px'; p.style.top = y + 'px';
        p.style.background = ['#fff', '#7cc4ff', '#ff5a5f'][i % 3];
        sparkLayer.appendChild(p);
        var ang = i * 2.4, d = many ? 40 + (i % 6) * 12 : 16 + (i % 4) * 8;
        var a = p.animate([{ transform: 'translate(0,0)', opacity: 1 },
          { transform: 'translate(' + Math.cos(ang) * d + 'px,' + (Math.sin(ang) * d + 30) + 'px)', opacity: 0 }],
          { duration: many ? 900 : 420, easing: 'cubic-bezier(.12,.55,.4,1)', fill: 'forwards' });
        a.onfinish = (function (el) { return function () { el.remove(); }; })(p);
      }
    }

    function finish() {
      busy = false; penguin.style.willChange = parcel.style.willChange = 'auto'; idle();
      if (pending && alive && !hidden()) { var next = pending; pending = null; run(next); } else pending = null;
    }

    function run(ev) {
      bubble.textContent = ev.delta > 0 ? lines.add[n++ % 3] : lines.remove;
      if (reduced.matches || hidden()) { idle(); return; }
      busy = true; measure();
      var g = geo, start = g.s * 0.9, stop = g.bx - 26, contact = g.s * 0.84, bx = g.bx + 30;
      parcel.dataset.kind = ev.kind || 'cube';
      parcel.querySelector('.np-mult').textContent = ev.count > 1 ? '×' + ev.count : '';
      penguin.style.willChange = parcel.style.willChange = 'transform';
      root.dataset.motion = ev.delta > 0 ? 'push' : 'pull';
      var dur = ev.delta > 0 ? 560 : 600, t0 = performance.now(), landed = false;
      function frame(now) {
        if (!alive) return;
        if (hidden()) { finish(); return; }
        var t = clamp((now - t0) / dur), q;
        if (ev.delta > 0) {
          if (t < 0.18) { q = ease(t / 0.18); sprite(1); place(lerp(g.home, start - contact, q), g.y, 4 * q); bag(start, g.py, 0, 0.7 + 0.3 * q, q); }
          else if (t < 0.55) { q = (t - 0.18) / 0.37; var x = lerp(start, stop, q * q); sprite(Math.floor(q * 6) % 2 ? 2 : 1); place(x - contact, g.y - Math.abs(Math.sin(q * Math.PI * 3)) * 3, 4); bag(x, g.py, -q * 7, 1, 1); }
          else if (t < 0.78) { q = (t - 0.55) / 0.23; sprite(2); place(stop - contact, g.y, 4 - 9 * q); bag(lerp(stop, bx, q), lerp(g.py, g.by, q) - Math.sin(q * Math.PI) * 50, lerp(-7, 19, q), 1 - 0.4 * q, 1); }
          else { if (!landed) { landed = true; sparkle(g.bx + 50, g.by - 10); } parcel.style.opacity = '0'; q = (t - 0.78) / 0.22; sprite(0); place(lerp(stop - contact, g.home, ease(q)), g.y - Math.sin(q * Math.PI) * 6, 0); basket.style.transform = 'scale(' + (1 + 0.07 * Math.sin(q * Math.PI)) + ',' + (1 - 0.06 * Math.sin(q * Math.PI)) + ')'; }
        } else {
          var near = stop - contact;
          if (t < 0.22) { q = ease(t / 0.22); sprite(1); place(lerp(g.home, near, q), g.y, 5); parcel.style.opacity = '0'; }
          else if (t < 0.45) { q = (t - 0.22) / 0.23; sprite(3); place(near, g.y, -6 * q); bag(lerp(bx, stop, q), lerp(g.by, g.py, q) - Math.sin(q * Math.PI) * 44, -9 * q, 0.6 + 0.4 * q, 1); basket.style.transform = 'rotate(' + (Math.sin(q * Math.PI) * -4) + 'deg)'; }
          else if (t < 0.85) { q = ease((t - 0.45) / 0.4); var x2 = lerp(stop, start, q); sprite(3); place(x2 - contact, g.y, -7); bag(x2, g.py, -7, 1, 1); }
          else { q = (t - 0.85) / 0.15; sprite(0); place(lerp(start - contact, g.home, q), g.y, 0); bag(start, g.py - 14 * q, -7, 1 - 0.5 * q, 1 - q); if (!landed) { landed = true; sparkle(start + 18, g.py + 16); } }
        }
        if (t < 1) raf = requestAnimationFrame(frame); else finish();
      }
      raf = requestAnimationFrame(frame);
    }

    // Coalesce visual events: one running motion + at most one pending (counts merged).
    function enqueue(delta, o) {
      var ev = { delta: delta, kind: o && o.productId, count: (o && o.count) || 1 };
      if (busy) { if (pending && pending.kind === ev.kind && pending.delta === delta) pending.count += ev.count; else pending = ev; }
      else run(ev);
    }

    var api = {
      playAdd: function (o) { try { enqueue(1, o); } catch (e) { } },
      playRemove: function (o) { try { enqueue(-1, o); } catch (e) { } },
      syncCart: function (snap) { try { count.textContent = snap.boxes; root.classList.toggle('np-has-items', snap.boxes > 0); } catch (e) { } },
      celebrate: function (o) {
        try {
          var id = o && o.orderId; if (!id || celebrated[id]) return; celebrated[id] = true;
          api.cancel(); measure(); root.dataset.motion = 'clap'; bubble.textContent = 'Added to your basket!';
          var cx = (geo.w - geo.s) / 2; sprite(0, true); place(cx, geo.y, 0, 1.08);
          if (reduced.matches) return;
          sparkle(geo.w / 2, 60, true); var t0 = performance.now();
          (function clap(now) { if (!alive || reduced.matches) { idle(); return; }
            var el = now - t0, t = clamp(el / 1300), closed = Math.floor(el / 135) % 2 === 1;
            sprite(closed ? 1 : 0, true);
            place(cx, geo.y - (t < 0.25 ? Math.sin(t / 0.25 * Math.PI) * 14 : 0), 0, 1.08);
            if (t < 1) raf = requestAnimationFrame(clap); else { root.dataset.motion = 'idle'; }
          })(t0);
        } catch (e) { }
      },
      cancel: function () { cancelAnimationFrame(raf); busy = false; pending = null; sparkLayer.replaceChildren(); idle(); },
      destroy: function () { alive = false; api.cancel(); ro.disconnect(); document.removeEventListener('visibilitychange', onVis); reduced.removeEventListener && reduced.removeEventListener('change', onReduce); }
    };

    var ro = new ResizeObserver(function () { geo = null; if (!busy) idle(); });
    ro.observe(stage);
    function onVis() { if (document.hidden) { cancelAnimationFrame(raf); pending = null; busy = false; idle(); } }
    function onReduce() { if (reduced.matches) api.cancel(); }
    document.addEventListener('visibilitychange', onVis);
    reduced.addEventListener && reduced.addEventListener('change', onReduce);
    idle();
    return api;
  }

  function boot() {
    document.querySelectorAll('[data-np-stage]').forEach(function (el) {
      if (el.npApi) return;
      try { el.npApi = NicePenguinStage(el); } catch (e) { }
    });
  }
  window.NicePenguinStage = NicePenguinStage;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
